import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, KeyValues3, KeyValues5, LocalService, Paging, StatusWithId, SupplierInitialization, SupplierWrapper, Wrappers15 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {
  private controllerName = service_controllers_methods.supplier.controller;
  private methods = service_controllers_methods.supplier.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getSupplierInitialization(strId: string, languageCode?: string): Observable<SupplierInitialization> {
    let body = {
      sel: this.localService.getSelected(languageCode),
      dt: { v1: strId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSupplierInitialization, body);
  }

  public getSupplier(strId: string, isAllInforRequired = false, languageCode?: string): Observable<SupplierWrapper> {
    let body = {
      sel: this.localService.getSelected(languageCode),
      strId: strId,
      isAllInforRequired: isAllInforRequired
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSupplier, body);
  }

  public saveSupplier(wrapper: SupplierWrapper): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      wrapper: wrapper
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveSupplier, body);
  }

  public getSuppliers(businessId: string, paging?: Paging, isActive: boolean = true): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: businessId, v2: isActive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSuppliers, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public getSearchedSuppliers(businessId: string, searchKey?: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: searchKey } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSearchedSuppliers, body, false);
  }
}
